import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcBRYz7u7J7OnYGizpZJ1YmaaL7PwLEXI",
  authDomain: "sagedemo-8850b.firebaseapp.com",
  databaseURL: "https://sagedemo-8850b-default-rtdb.firebaseio.com",
  projectId: "sagedemo-8850b",
  storageBucket: "sagedemo-8850b.appspot.com",
  messagingSenderId: "576099907220",
  appId: "1:576099907220:web:d774ff312cfeb96ce5e681",
  measurementId: "G-ZDMNF4W2K5",
};

//initialize firebase app
initializeApp(firebaseConfig);

//init services
export const firestoreDB = getFirestore();
